import { AbsoluteCenter, Skeleton, VStack } from '@masterplandev/ui'

export const CardSkeleton = () => (
  <VStack
    boxShadow="xl"
    position="relative"
    h={{ base: '219px', md: '240px', lg: '210px' }}
    w={{ base: '146px', md: '160px', lg: '140px' }}>
    <AbsoluteCenter>
      <Skeleton
        clipPath="path('M31 1.31a8 8 0 0 1 8 0l26.641 15.38a8 8 0 0 1 4 6.929V54.38a8 8 0 0 1-4 6.928L39 76.691a8 8 0 0 1-8 0L4.359 61.309a8 8 0 0 1-4-6.928V23.62a8 8 0 0 1 4-6.928L31 1.309Z')"
        h="80px"
        mb="1"
        w="70px"
      />
    </AbsoluteCenter>
  </VStack>
)
